import { ReactiveVar, makeVar } from '@apollo/client';
import { staticDrawerColumnsDocuments } from '../DocumentsTable.constants';
import {
  documentsTableColumns,
  pendingDocumentsTableColumns,
} from '../DocumentsTableColumns';

const _pendingDocumentsTableColumns = pendingDocumentsTableColumns.filter(
  (pColumn) =>
    !documentsTableColumns.find((column) => pColumn.field === column.field),
);

interface DocumentsTableColumn {
  field: string;
}

interface DocumentsTableColumnsDialog {
  open: boolean;
  columns: DocumentsTableColumn[];
  enabledColumns: Record<string, boolean>;
}

const documentsTableColumnsDrawerDefault: DocumentsTableColumnsDialog = {
  open: false,
  columns: [...documentsTableColumns, ..._pendingDocumentsTableColumns],
  enabledColumns: localStorage.documentsColumns
    ? JSON.parse(localStorage.documentsColumns)
    : staticDrawerColumnsDocuments,
};

export const documentsTableColumnsDialogVar: ReactiveVar<DocumentsTableColumnsDialog> =
  makeVar(documentsTableColumnsDrawerDefault);

export const resetDocumentsTableColumnsDialogVar = (): void => {
  documentsTableColumnsDialogVar(documentsTableColumnsDrawerDefault);
};

export const setDocumentsTableColumnsDialogVar = (
  input: Partial<DocumentsTableColumnsDialog>,
): void => {
  if (input.enabledColumns) {
    localStorage.documentsColumns = JSON.stringify(input.enabledColumns);
  }
  documentsTableColumnsDialogVar({
    ...documentsTableColumnsDialogVar(),
    ...input,
  });
};
